export default "__VITE_ASSET__BISuyqCC__"